module.exports = __webpack_public_path__ + "static/media/Two_Hand_B.03ef6d48.png";